<template>

	<div class="d-flex flex-column flex-sm-row align-center ga-4 mt-4">
		<span class="referral__sub-heading me-auto">Your Referral Code</span>

		<span class="d-flex flex-row ga-4 justify-end align-self-end">
			<button @click="navigateToMyReferrals" class="button--primary rounded-pill px-8 py-3 d-flex align-self-end">
				My Referrals
			</button>

			<button @click=navigateToFaq(9) class="button--primary rounded-pill px-8 py-3 d-flex align-self-end">
				FAQ
			</button>
		</span>
	</div>


	<v-row class="mt-4">

		<v-col cols="12" sm="6" md="8" lg="8" xl="8">
			<ReferralCodeTile />
		</v-col>


		<v-col cols="12" sm="6" md="4" lg="4" xl="4">
			<CommissionTile />
		</v-col>

	</v-row>

</template>



<script setup>

import { useRouter } from 'vue-router';
import CommissionTile from "@/components/Tiles/Referral/Commission-Tile.vue";
import ReferralCodeTile from "@/components/Tiles/Referral/Referral-Code-Tile.vue";

const router = useRouter();

const navigateToFaq = (panelIndex)  => {
	router.push({ name: "FAQs", query: { panelIndex } });
}

const navigateToMyReferrals = () => {
	router.push({ name: "My Referrals" });
}

</script>